import { getTiming } from "./transitions-lib.js";
import { getSceneDurationInSeconds, } from "./getSceneDurationInSeconds.js";
import { toSeconds } from "./frames-lib.js";
export function getCompositionDurationInSeconds(renderConfig, theme) {
    const fps = renderConfig.videoFrame.fps;
    const sceneTransitionDurationInFrames = getTiming(theme.styles.sceneTransition, fps)?.getDurationInFrames({
        fps: renderConfig.videoFrame.fps,
    }) || 0;
    // We need to remove the transition time from the last scene,
    // but the last scene might be an outro that is removed because
    // of branding config. So we first filter the scenes
    // to remove 0 duration scenes, then calculate the duration from that.
    const nonZeroDurationScenes = theme.scenes.filter((scene) => getSceneDurationInSeconds(scene, renderConfig, theme) > 0);
    return nonZeroDurationScenes.reduce((prev, scene, index) => {
        const isLastScene = index === nonZeroDurationScenes.length - 1;
        // Each scene is going to overlap with the next scene during the transition.
        // This is something remotion will do automatically with transitions.
        // So that portion of time for each scene is essentially shared with its
        // next scene (except for the last scene). We will subtract this time off of
        // each scene (except for the last scene) because otherwise it will be
        // counted twice. This isn't time we add on to each scene that needs to be
        // subtracted off, it's a consequence of the way Remotion overlaps scenes in
        // transition.
        const transitionTimeSeconds = isLastScene
            ? 0
            : toSeconds(sceneTransitionDurationInFrames, fps);
        const sceneDurationSeconds = getSceneDurationInSeconds(scene, renderConfig, theme);
        return prev + sceneDurationSeconds - transitionTimeSeconds;
    }, 0);
}
